import React from 'react';
import { Box } from '@mui/material';
// SWITCH TO REFACTORED VERSION
import RefactoredRegisterAssetPage from '../../pages/RefactoredRegisterAssetPage';
import { debugLog, logger, LogLevel } from '../../utils/logger';
import { TaxonomyProvider } from '../../contexts/TaxonomyContext';
import { TaxonomyDataProvider } from '../../providers/taxonomy/TaxonomyDataProvider';

/**
 * Wrapper component that renders the REFACTORED RegisterAssetPage implementation
 * Switched to use the new modular architecture for better maintainability
 */
const RegisterAssetPageWrapper: React.FC = React.memo(() => {
  // Log for context using environment-aware logger
  debugLog(
    '[RegisterAssetPageWrapper] Using REFACTORED implementation with modular architecture'
  );

  // Also log with structured logger for UI category
  logger.ui(
    LogLevel.INFO,
    'RegisterAssetPageWrapper initialized with REFACTORED workflow'
  );

  return (
    <Box position="relative">
      <TaxonomyDataProvider>
        <TaxonomyProvider>
          <RefactoredRegisterAssetPage />
        </TaxonomyProvider>
      </TaxonomyDataProvider>
    </Box>
  );
});

export default RegisterAssetPageWrapper;
